import React, { useState, useEffect, useRef } from 'react';

import 'react-datepicker/dist/react-datepicker.css';
import './CustomDatePicker.css';
import {
  BagsBox,
  BagsTitleBox,
  BagsBodyBox,
  BagsTitle,
  IconEye,
  PreviewButton,
  SaleButton,
  ButtonWrap,
  FieldWrapper,

  Fields,

  VerticalBox,

  Categorie,
  Categories,
  QuantityButton,
  QuantityInputWrapper,
  IconInc,
  IconDec,
  InputCount,
  BGTitle,
  Label0,

  BagsStatus,
  Texts, Titles,
  IconWarn,
  IconBag,
  SubFieldWrapper,
  ChangeButton,
  TempLink,
  WrapIcon,
  IconReg,
  Textsp,
  DeleteButton,
  IconTrash,
  EditButton,
  IconEdit,
  IconDown,
  DeleteUse,
  DeleteUseItem,
  LabelBox,
  LabelText,
  Span,
  Span1,
  IconLabel,
  IconRepeat,
  IconCircleCrs
} from './ViewBag.styled';
import { useFetchPricesQuery } from '../../../redux/category/categoriesApi';
import { useFetchShopsQuery } from '../../../redux/shops/shopsApi';
// import { addDays, format, parse } from 'date-fns';
import { useDeleteBagMutation, useEditBagCountMutation, useEditBagDatesMutation, useEditBagMutation, useEditBagShopMutation, useGetBagQuery, usePublishBagMutation } from '../../../redux/bags/bagsApi';
import { useNavigate, useParams } from 'react-router-dom';

import { determineBagParameters, formatDate, formatDateText, formatDateTimeRange, formatedRepeat, formatRepeat, returnStatus } from '../../../utils/function';
import BagModal from '../../modal/BagModal';
import ImageAnimation1 from 'components/layout/loader/ImageAnimation1';
import { showErrorToast, showInfoToast, showSuccessToast, showWarningToast } from 'utils/showToast';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../redux/auth/selectors';
import AllertFinance from 'components/modal/AllertFinance';
import { url1 } from 'components/other/terms';
import { io } from 'socket.io-client';
import { selectToken } from '../../../redux/auth/selectors';
import AllertPrro from 'components/modal/AllertPrro';





const ViewBag = () => {
  const token = useSelector(selectToken);
  const user = useSelector(selectUser)
  const navigate = useNavigate();
  const { id } = useParams();
  const deleteUseRef = useRef(null);
  const { data: shopsData, isLoading: isLoadingShop } = useFetchShopsQuery();
  const [editBagCount, { isLoading: isLoadingCount }] = useEditBagCountMutation();
  const [deleteBag, { isLoading: isLoadingDelete }] = useDeleteBagMutation();
  const [publishBag, { isLoading: isLoadingPublish }] = usePublishBagMutation();
  const [shops, setShops] = useState([]);
  const { data: pricesData } = useFetchPricesQuery();
  const { data: bag1, isLoading: isLoadingBag } = useGetBagQuery(id);
  const [paramBag, setParamBag] = useState({});
  const [priceBags, setPriceBags] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const [bag, setBag] = useState(null);
  const [title, setTitle] = useState('');
  const [type, setType] = useState('');
  const [typeBtn, setTypeBtn] = useState('');
  const [isModalOpen2, setModalOpen2] = useState(false);
  const [isModalOpen3, setModalOpen3] = useState(false);
  // const socketRef = useRef(null);
  // useEffect(() => {
  //   const baseUrl = url1 + ":443";
  //   const newSocket = io.connect(baseUrl, {
  //     path: "/ws",
  //     query: {
  //       auth_token: token,
  //     },
  //     secure: true
  //   });
  //   newSocket.join = () => {
  //     console.log('WebSocket Connected');
  //     // Відправляємо запит на отримання поточного стану кошика
  //     socketRef.current.send(JSON.stringify({ action: 'subscribe', bagId: id }));
  //   };

  //   newSocket.current.onmessage = (event) => {
  //     const data = JSON.parse(event.data);
  //     if (data.type === 'updateBag') {
  //       setBag(data.bag);
  //       setQuantity(data.bag.count);
  //     }
  //   };

  //   newSocket.current.onerror = (error) => {
  //     console.error('WebSocket Error:', error);
  //   };

  //   newSocket.current.onclose = () => {
  //     console.log('WebSocket Disconnected');
  //   };

  //   return () => {
  //     newSocket.current.close();
  //   };
  // }, []);


  const handleOpenModal3 = () => {
    setModalOpen3(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseModal3= () => {
    setModalOpen3(false);

    document.body.style.overflow = 'auto';

  };
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        handleCloseModal3();

      }
    };

    if (isModalOpen3) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalOpen3]);
  
  const handleOpenModal2 = () => {
    setModalOpen2(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseModal2 = () => {
    setModalOpen2(false);
    
    document.body.style.overflow = 'auto';
 
  };

  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        handleCloseModal2();

      }
    };

    if (isModalOpen2) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalOpen2]);

  const [isModalOpen, setModalOpen] = useState(false);
  const handleOpenModal = () => {
    document.body.style.overflow = 'hidden';
    document.querySelector('#myTargetDiv').style.overflowY = 'hidden';
console.log('<<ПОЧАТОК ДОСЛІДЖЕННЯ ЛОГІВ:>> ', );
    setModalOpen(true);
    
  };

  const handleCloseModal = () => {
    console.log('<<КІНЕЦЬ ДОСЛІДЖЕННЯ ЛОГІВ :>> ',);
    setModalOpen(false);
    setTitle("")
    document.body.style.overflow = 'auto';
    document.querySelector('#myTargetDiv').style.overflowY = 'auto';
    setType('')
  };

  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        handleCloseModal();
        setType('')
      }
    };

    if (isModalOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalOpen]);
  useEffect(() => {
    if (shopsData) {
      setShops(shopsData)
    }
  }, [shopsData]);


  useEffect(() => {
    if (bag1) {
      console.log(bag1)
      console.log('determineBagParameters(bag) :>> ', determineBagParameters(bag1));
     setBag(bag1)
      setParamBag(determineBagParameters(bag1))
      setQuantity(bag1.count)
    }
  }, [bag1]);
  useEffect(() => {
    if (pricesData) {
      setPriceBags(pricesData);
    }
  }, [pricesData]);
  const formatBagPrice = (priceBag) => {
    const price = pricesData?.find(item => parseInt(item.price) === priceBag);
    return `${price.name} - ${price.price} грн.`;
  };
  const incrementQuantity = async () => {
    setQuantity(quantity + 1);

    await editBagCount({ id: bag?.id, count: quantity + 1 })
  };

  const decrementQuantity = async () => {
    if (quantity > 1) {
      await editBagCount({ id: bag?.id, count: quantity - 1 })
      if ((quantity - 1) === bag?.reserved_count)
        showWarningToast(`Зменшення кількості кошиків до рівня менше ${bag?.reserved_count} одиниць може призвести до скасування бронювань в користувачів додатку`)
      setQuantity(quantity - 1);

    }
  };

  const handleButton = () => {
    switch (paramBag?.funct) {
      case 'repeat':
        navigate(`/main/addbag/${bag?.id}?mode=repeat`);
        break;
      case 'publish':
       console.log('usersfgdfs:>> ', user);
        // if (!user?.merchant?.expires_at) {
        //   showInfoToast('Спочатку оплатіть рахунок')
        //   return
        // }
        if (!user?.merchant?.organizationName || !user?.merchant?.organizationCode || !user?.merchant?.portmone_id || !user?.merchant?.portmone_key || !user?.merchant?.portmone_login || !user?.merchant?.portmone_pass) {
          handleOpenModal2();
          return
        }
        console.log('usersfgdfs3223:>> ', user);
        const selectPointObj = shopsData?.find(item => item.id === Number(bag.shop.id));
      console.log('selectPointObj  :>> ', selectPointObj );
        if (!selectPointObj.cash_register_type) {handleOpenModal3();
        return
        }
        else
        {publish();}
        break;
      case 'unpublish':
        deletebag();
        break;
      default:
        break;
    }

  }
  const publish = async () => {


    try {
      const response = await publishBag(id).unwrap();
 showSuccessToast(response.mesage);
    } catch (error) {
      console.log('error :>> ', error);
      showErrorToast(error.data.message)
    }

  }

  const deletebag = async () => {


    try {
      await deleteBag(id).unwrap();

    } catch (error) {
      console.log('error :>> ', error);
      showErrorToast(error.data.message)
    }

  }


  const handleDelete = () => {
    if (bag?.template) {
      setTypeBtn('visible')
    } else {
      setType(bag?.schedule ? 'deletereg' : 'delete');
      setTitle(bag?.schedule ? 'Видалити регулярний диво-кошик?' : 'Видалити диво-кошик?');
      handleOpenModal()
    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (deleteUseRef.current && !deleteUseRef.current.contains(event.target)) {
        setTypeBtn(''); // Закрити меню
      }
    };

    if (typeBtn === 'visible') {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [typeBtn]);


  return (
    <BagsBox>
      {isLoadingShop || isLoadingBag || isLoadingPublish || !bag ? <ImageAnimation1 /> : <>
        <BagsTitleBox>
          <BagsTitle> <BGTitle>{bag?.name} </BGTitle>  <div style={{display:'flex',gap:'12px'}}> 

            <BagsStatus statusCol={paramBag.bgCol}>{bag?.statusName}</BagsStatus>{bag?.schedule && <WrapIcon><IconReg /></WrapIcon>}</div>
          </BagsTitle>

          <ButtonWrap>
            <PreviewButton type='button' onClick={() => { setType('preview'); setTitle("Превью"); handleOpenModal() }}><IconEye /><Span>Превью</Span></PreviewButton>
            {paramBag?.funct && <SaleButton type='button' onClick={handleButton} statusBtnCol={paramBag?.statusBtnCol} >{paramBag.statusIcon === 1?<IconLabel/>:paramBag.statusIcon===2?<IconCircleCrs/>:<IconRepeat/> }<Span1>{paramBag?.statusBtn}</Span1></SaleButton>}
          </ButtonWrap>
        </BagsTitleBox>

        <BagsBodyBox>
          <Fields>

            <FieldWrapper>
              <SubFieldWrapper>
                <Titles>Що в середині</Titles>
                <Texts>{bag?.description}</Texts>
              </SubFieldWrapper>

              <SubFieldWrapper>
                <Titles>Примітки</Titles>
                {bag?.possibly_allergic && <Texts Texts > <IconWarn /> Містить алергени</Texts >}
                {bag?.possibly_buffet && <Texts Texts > <IconWarn /> Містить їжу зі шведського столу</Texts >}
                <Texts Texts > <IconBag />  {bag?.packing_type === 'own' ? "Просимо прийти зі свою упаковкою" : "Продавець надає упаковку до замовлення"}</Texts >
              </SubFieldWrapper>
            </FieldWrapper>


            <FieldWrapper>
              <SubFieldWrapper >
                <Titles>Категорії</Titles>
                <Categories id="category">
                  {bag?.categories.filter(item => item.type === 'category').map((cat) => (
                    <Categorie
                      key={cat.id}
                      className={'selected'}
                    >
                      {cat.name}
                    </Categorie>
                  ))}
                </Categories>
              </SubFieldWrapper>

              <SubFieldWrapper>
                <Titles>Дієта</Titles>
                <Categories id="category">
                  {bag?.categories.filter(item => item.type !== 'category').length !== 0 ? bag?.categories.filter(item => item.type !== 'category').map((cat) => (
                    <Categorie
                      key={cat.id}
                      className={'selected'}
                    >
                      {cat.name}
                    </Categorie>
                  )) : "-"}
                </Categories>
              </SubFieldWrapper>
            </FieldWrapper>

            <FieldWrapper>
              <SubFieldWrapper>
                <Titles>Орієнтовна повна вартість</Titles>
                <Texts>{bag?.old_price} грн.</Texts>
              </SubFieldWrapper>

              <SubFieldWrapper>
                <Titles>Ціна диво-кошика</Titles>
                <Texts>{bag?.price && pricesData && formatBagPrice(bag?.price)}</Texts>
              </SubFieldWrapper>
            </FieldWrapper>
            <FieldWrapper>
              <SubFieldWrapper style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}>
                <LabelBox>
                  <Label0 htmlFor="bagQuantity">Кількість кошиків</Label0>
                  {bag?.status !== 'draft' && <LabelText>{paramBag.reservedWord}</LabelText>}
                </LabelBox>
                {!paramBag.quantyHide && <QuantityInputWrapper>
                  <QuantityButton type='button' onClick={decrementQuantity}><IconDec disabled={quantity > 1 ? true : false} /></QuantityButton>
                  <InputCount
                    id="bagQuantity"

                    min="1"
                    value={quantity}
                    readOnly
                  />
                  <QuantityButton type='button' onClick={incrementQuantity}><IconInc /></QuantityButton>
                </QuantityInputWrapper>}
              </SubFieldWrapper>

              <SubFieldWrapper style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }} >
                <VerticalBox>
                  <Titles>Час отримання</Titles>
                  <Texts>{formatDateTimeRange(bag?.datetime_from, bag?.datetime_to, bag?.schedule ? true : false)}</Texts>
                </VerticalBox>
                {!paramBag?.allBtnHide && <ChangeButton onClick={() => { setType('time'); setTitle("Змінити час отримання"); handleOpenModal() }}><IconEdit className="mob" /><Span>Змінити</Span></ChangeButton>}
              </SubFieldWrapper>
            </FieldWrapper>

            <FieldWrapper style={{ width: '100%' }}>
              <SubFieldWrapper style={{ width: bag?.schedule ? 'calc((100% - 16px) / 2)' : '100%', display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }} >
                <VerticalBox style={{ width: 'calc(100% - 131px)' }}>
                  <Titles>Точка видачі</Titles>
                  <Texts>{bag?.shop?.name}</Texts>
                  <Textsp>{bag?.shop?.address}</Textsp>
                </VerticalBox>
                {!paramBag?.pointBtnHide && <ChangeButton onClick={() => { setType('shop'); setTitle("Змінити точку видачі"); handleOpenModal() }} ><IconEdit className="mob" /><Span>Змінити</Span></ChangeButton>}
              </SubFieldWrapper>
              {bag?.schedule && <SubFieldWrapper style={{ width: bag?.schedule ? 'calc((100% - 16px) / 2)' : '100%',display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }} >
                <VerticalBox>
                  <Titles>Кошик повторюється </Titles>
                  <Texts>{formatRepeat(bag?.schedule?.period)} ({formatedRepeat(bag?.schedule)})</Texts>
                  <Textsp>з {formatDate(bag?.schedule?.calculated_start)} {bag?.schedule?.calculated_end && `по ${formatDate(bag?.schedule?.calculated_end)}`}</Textsp>
                </VerticalBox>
                {!paramBag?.allBtnHide && <ChangeButton onClick={() => { setType('scheldule'); setTitle("Автоматизація"); handleOpenModal() }}><IconEdit className="mob" /><Span>Змінити</Span></ChangeButton>}
              </SubFieldWrapper>}
            </FieldWrapper>
            {bag?.template &&
              <FieldWrapper >
                <SubFieldWrapper style={{ width: '100%', display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }} >
                  <Texts>Кошик створено на основі шаблону:  <TempLink to={`/main/viewbag/${bag?.template}`}>Диво-кошик</TempLink> </Texts>
                </SubFieldWrapper>


              </FieldWrapper>}
            {!paramBag?.btnWrapHide &&
              <FieldWrapper style={{ height: 'fit-content', display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }} >
                <DeleteButton style={{ width: paramBag.deleteWidth }} onClick={handleDelete} ><IconTrash />Видалити кошик
                  {bag?.template && <IconDown/>}
                  <DeleteUse ref={deleteUseRef} className={typeBtn === 'visible' && typeBtn}>
                    <DeleteUseItem onClick={() => { setType('delete'); setTitle('Видалити диво-кошик?'); handleOpenModal() }}>Тільки цей кошик</DeleteUseItem>
                    <DeleteUseItem onClick={() => { setType('deleteall'); setTitle("Видалити подальші диво-кошики?"); handleOpenModal() }}>Всі подальші кошики</DeleteUseItem>
                  </DeleteUse></DeleteButton>
                {!paramBag?.editBtnHide && <EditButton to={formatDateText(bag?.datetime_from, bag?.datetime_to, bag?.schedule ? true : false) ? `/main/addbag/${bag?.id}?currentDay=${formatDateText(bag?.datetime_from, bag?.datetime_to, bag?.schedule ? true : false) }` :`/main/addbag/${bag?.id}`}><IconEdit />Редагувати</EditButton>}
              </FieldWrapper>
            }

          </Fields>
        </BagsBodyBox>
      </>}
      {
        isModalOpen2 && (
          <AllertFinance onClose={handleCloseModal2}  />
        )
      }
      {
        isModalOpen3 && (
          <AllertPrro onClose={handleCloseModal3} onFunc={publish} />
        )
      }
      {
        isModalOpen && !isLoadingShop && (
          <BagModal nqe={true} onClose={handleCloseModal} bag={bag} title={title} shopsData={shops} type={type} pointd={`${bag?.shop?.name} (${bag?.shop?.address})`} />
        )
      }
    </BagsBox >
  );
};

export default ViewBag;